import React, { useEffect, useState } from 'react'
import { NineGridIcon, FourGridIcon } from '../SvgIcons'
import {
  Container,
  ViewSmallBox,
  ViewLargeBox
} from './styles'

export const SwitchGrid = (props) => {
  const {
    setIsMoreView,
    isMoreView
  } = props

  const [large, setIsLarge] = useState(isMoreView)

  const handleChangeGridView = (index) => {
    if (index === large) return
    setIsMoreView(index)
    setIsLarge(index)
  }

  useEffect(() => {
    setIsLarge(isMoreView)
  }, [isMoreView])

  return (
    <Container>
      <ViewSmallBox
        active={!large}
        onClick={() => handleChangeGridView(false)}
      >
        <FourGridIcon />
      </ViewSmallBox>
      <ViewLargeBox
        active={large}
        onClick={() => handleChangeGridView(true)}
      >
        <NineGridIcon />
      </ViewLargeBox>
    </Container>
  )
}
